"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionStatuses = void 0;
var SubscriptionStatuses;
(function (SubscriptionStatuses) {
    SubscriptionStatuses["STATUS_ACTIVE"] = "ACTIVE";
    SubscriptionStatuses["STATUS_INACTIVE"] = "INACTIVE";
    SubscriptionStatuses["STATUS_DELETED"] = "DELETED";
})(SubscriptionStatuses || (exports.SubscriptionStatuses = SubscriptionStatuses = {}));
//# sourceMappingURL=subscription-statuses.enum.js.map